import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';

const FeatureFlagsContext = createContext(null);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

const defaultFlags = {};

export function FeatureFlagsProvider({ children }) {
  const { user } = useAuth();
  const [flags, setFlags] = useState(defaultFlags);

  const fetchFlags = useCallback(async () => {
    try {
      const res = await api.get('/api/feature-flags');
      setFlags(res.data && typeof res.data === 'object' ? res.data : {});
    } catch {
      setFlags(defaultFlags);
    }
  }, []);

  useEffect(() => {
    if (user) fetchFlags();
    else setFlags(defaultFlags);
  }, [user, fetchFlags]);

  return (
    <FeatureFlagsContext.Provider value={{ ...flags, refetchFlags: fetchFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}
